"use strict";

(function (Drupal) {
  Drupal.behaviors.webform = {
    attach: function attach(context, settings) {
      var form = context.querySelector('.webform-submission-newsletter-signup-form');
      var errorMessage = context.querySelector('div[data-drupal-messages]');
      var formWrapper = context.querySelector('.webform-ajax-form-wrapper');
      form && formWrapper && errorMessage && formWrapper.insertBefore(errorMessage, form);
    }
  };
})(Drupal);